// Copyright ©️ 2026 eVolve MEP, LLC

import React, { useState, type ReactNode } from 'react';

import { type LoaderProps, Loader, Flex, type FlexProps } from '@mantine/core';

type Props = {
  visible: boolean;
  flexProps?: FlexProps;
  children?: ReactNode;
} & LoaderProps;

export const FadingLoader = ({ visible: parentVisible, flexProps, children, ...props }: Props) => {
  const [visible, setVisible] = useState(parentVisible);
  return (
    <Flex
      align="center"
      justify="center"
      style={{
        opacity: parentVisible ? 1 : 0,
        transition: 'opacity 150ms ease-in-out',
      }}
      {...flexProps}
      onTransitionStart={(e) => {
        setVisible(true);
        flexProps?.onTransitionStart?.(e);
      }}
      onTransitionEnd={(e) => {
        setVisible(parentVisible);
        flexProps?.onTransitionEnd?.(e);
      }}
    >
      {children}
      {visible && <Loader {...props} />}
    </Flex>
  );
};
